var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", { staticClass: "article-list-item" }, [
    _c("h4", { staticClass: "title" }, [
      _c(
        "a",
        { attrs: { href: _vm.result.NodeAliasPath, title: _vm.result.Title } },
        [_vm._v(_vm._s(_vm.result.Title))]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "meta" }, [
      _c("span", { staticClass: "date" }, [
        _vm._v(_vm._s(_vm.formatDate(_vm.result.ArticleDate)))
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-59a27e1a", { render: render, staticRenderFns: staticRenderFns })
  }
}